import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Permissions, UserTypePermission } from 'src/app/core/permissions/Permissions';
import { LeftNavModel } from '../navigation';
import { goToUrl } from '../navigation.component';
import { Roles } from '../../user-admin/roles/models/Roles';

@Component({
    selector: 'nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NavMenuComponent implements OnChanges {
    @Input() permissions: string[] = [];
    @Input() role?: string;
    @Input() goToUrl!: goToUrl;
    @Output() emitValueMenuObj = new EventEmitter<LeftNavModel[]>();

    leftNavigation: LeftNavModel[] = [];

    constructor() {}

    ngOnChanges(): void {
        this.leftNavigation = [
            {
                icon: 'zmdi zmdi-chart',
                name: 'PAGE.NAV.ANALYSIS.TXT',
                permission: this.permissions.includes(Permissions.READ_ANALYSIS) || this.permissions.includes(Permissions.CREATE_TEMPLATES),
                items: [
                    {
                        name: 'PAGE.NAV.NEW_ANALYSIS.TXT',
                        permission: true,
                        items: [
                            {
                                name: 'ENUM.ANALYIS_TYPE.FREE',
                                route: 'analysis/new/FREE/header',
                                permission: this.permissions.includes(Permissions.READ_ANALYSIS) || this.permissions.includes(Permissions.CREATE_TEMPLATES)
                            },
                            {
                                name: 'PAGE.NAV.GROUP_ANALYSIS.TXT',
                                route: 'analysis/new/AVERAGE/header',
                                permission: this.permissions.includes(Permissions.READ_ANALYSIS)
                            },
                            {
                                name: 'ENUM.ANALYIS_TYPE.SUPPORT.NAV',
                                route: 'analysis/new/SUPPORT/header',
                                permission: this.permissions.includes(Permissions.READ_ANALYSIS)
                            },
                            {
                                name: 'PAGE.ANALYSIS.FROMTEMPLATE.LBL',
                                route: '/analysis/#/search/template/favorite',
                                permission: this.permissions.includes(Permissions.READ_ANALYSIS)
                            },
                            {
                                name: 'PAGE.ANALYSIS.FROMCLIPBOARD.LBL',
                                route: '/analysis/#/analysis/clipboard',
                                identifier: 'fromClipboard',
                                permission: true
                            },
                            {
                                name: 'PAGE.ANALYSIS.FROMXSENS.LBL',
                                route: '/dwsm/dashboard',
                                identifier: 'fromXsens',
                                permission: this.permissions.includes(Permissions.IMPORT_ANALYSIS)
                            },
                            {
                                name: 'PAGE.ANALYSIS.FROM_DWSM_LITE.LBL',
                                route: '/dwsm/dashboard',
                                identifier: 'fromDwsmLite',
                                permission: this.permissions.includes(Permissions.IMPORT_ANALYSIS)
                            }
                        ]
                    },
                    {
                        name: 'PAGE.GENERAL.SEARCH.LBL',
                        permission: true,
                        items: [
                            {
                                name: 'PAGE.NAV.ANALYSES_COUNTERMEASURES.TXT',
                                route: 'analysis-search',
                                permission: this.permissions.includes(Permissions.READ_ANALYSIS)
                            },
                            {
                                name: 'PAGE.SYSADMIN.ARCHIVE.LBL',
                                route: 'archive-search',
                                permission: this.role === Roles.SYSTEM_ADMIN
                            },
                            {
                                name: 'PAGE.ANALYSISEARCH.OWN_SEARCHES.LBL',
                                route: '/analysis/#/search/ownSearches',
                                permission: this.permissions.includes(Permissions.READ_ANALYSIS)
                            },
                            {
                                name: 'PAGE.NAV.SEARCH_TEMPLATE.TXT',
                                route: '/analysis/#/search/template/favorite',
                                permission: this.permissions.includes(Permissions.CREATE_TEMPLATES)
                            }
                        ]
                    }
                ]
            },
            {
                icon: 'zmdi zmdi-comment-edit',
                name: 'PAGE.NAV.REPORTS.TXT',
                permission: this.permissions.includes(Permissions.CREATE_REPORTS) && this.permissions.includes(Permissions.READ_ANALYSIS),
                items: [
                    {
                        name: 'PAGE.REPORT.ROTATIONS.LBL',
                        permission: true,
                        items: [
                            {
                                name: 'PAGE.REPORT.ROTATIONS.CREATE_ROTATIONS.LBL',
                                route: '/report/create-rotations',
                                permission: this.permissions.includes(Permissions.CREATE_REPORTS) && this.permissions.includes(Permissions.READ_ANALYSIS)
                            },
                            {
                                name: 'PAGE.REPORT.ROTATIONS.HISTORY.LBL',
                                route: '/report/rotations-history',
                                permission: this.permissions.includes(Permissions.CREATE_REPORTS) && this.permissions.includes(Permissions.READ_ANALYSIS)
                            }
                        ]
                    },
                    {
                        name: 'PAGE.REPORT.MY_RISK_REGISTER.TXT',
                        route: '/report/my-risk-register',
                        permission: this.permissions.includes(Permissions.CREATE_REPORTS)
                    },
                    {
                        name: 'CREATE.RISK_REGISTER.TXT',
                        route: '/report/create-risk-register',
                        permission: this.permissions.includes(Permissions.CREATE_REPORTS) && this.permissions.includes(Permissions.READ_ANALYSIS)
                    }
                ]
            },
            {
                icon: 'zmdi zmdi-collection-text',
                name: 'PAGE.NAV.WORKLIST.TXT',
                permission: this.permissions.includes(Permissions.READ_ANALYSIS) || this.permissions.includes(Permissions.USER_ADMINISTRATION),
                items: [
                    {
                        name: 'PAGE.WORKSTOCK.FAVORITES.LBL',
                        route: 'workstock/favorites',
                        permission: this.permissions.includes(Permissions.READ_ANALYSIS)
                    },
                    {
                        name: 'PAGE.WORK.BASKET.ANALYSIS.TXT',
                        route: 'workstock/analysis',
                        permission: this.permissions.includes(Permissions.READ_ANALYSIS)
                    },
                    {
                        name: 'PAGE.WORKSTOCK.COUNTERMEASURES.TXT',
                        route: 'workstock/countermeasures',
                        permission: this.permissions.includes(Permissions.READ_ANALYSIS)
                    },
                    {
                        name: 'PAGE.WORK.BASKET.SUPPLIER_PPP_ANALYSIS.TXT',
                        route: 'workstock/supplier-bmw',
                        permission: this.permissions.includes(Permissions.READ_ANALYSIS) && !this.permissions.includes(UserTypePermission.IS_SUPPLIER)
                    },
                    {
                        name: 'PAGE.WORK.BASKET.SUPPLIER_OWN_ANALYSIS.TXT',
                        route: 'workstock/supplier',
                        permission: this.permissions.includes(Permissions.READ_ANALYSIS) && this.permissions.includes(UserTypePermission.IS_SUPPLIER)
                    }
                ]
            },
            {
                icon: 'zmdi zmdi-settings',
                name: 'PAGE.NAV.ADMIN.TXT',
                permission:
                    this.permissions.includes(Permissions.USER_ADMINISTRATION_READ_ONLY) ||
                    this.permissions.includes(Permissions.USER_ADMINISTRATION) ||
                    this.permissions.includes(Permissions.MASTER_DATA_ADMINISTRATION) ||
                    this.permissions.includes(Permissions.SYSTEMADMINISTRATION),
                items: [
                    {
                        name: 'PAGE.NAV.USER_ADMIN.TXT',
                        permission:
                            this.permissions.includes(Permissions.USER_ADMINISTRATION_READ_ONLY) || this.permissions.includes(Permissions.USER_ADMINISTRATION),
                        items: [
                            {
                                name: 'PAGE.NAV.USER_ADMIN_ROLE.TXT',
                                route: '/useradmin/#/role',
                                permission: true
                            },
                            {
                                name: 'PAGE.NAV.USER_ADMIN_USER.TXT',
                                route: '/useradmin/#/user',
                                permission: true
                            }
                        ]
                    },
                    {
                        name: 'PAGE.NAV.MASTERDATA.TXT',
                        permission: this.permissions.includes(Permissions.MASTER_DATA_ADMINISTRATION),
                        items: [
                            {
                                name: 'PAGE.MASTERDATA.PLANT.TXT',
                                route: '/masterdata/#/plant',
                                permission: this.permissions.includes(Permissions.SYSTEMADMINISTRATION)
                            },
                            {
                                name: 'PAGE.MASTERDATA.BUILDING.TXT',
                                route: '/masterdata/#/building',
                                permission: true
                            },
                            {
                                name: 'PAGE.MASTERDATA.PLANT_CC_DC.LBL',
                                route: '/masterdata/#/plantCCDC',
                                permission: true
                            },
                            {
                                name: 'PAGE.MASTERDATA.PRODUCT_LINE.TXT',
                                route: '/masterdata/#/productLine',
                                permission: true
                            },
                            {
                                name: 'PAGE.MASTERDATA.DERIVATIVE.TXT',
                                route: '/masterdata/#/derivative',
                                permission: true
                            },
                            {
                                name: 'PAGE.MASTERDATA.TECHNOLOGY.TXT',
                                route: '/masterdata/#/technology',
                                permission: this.permissions.includes(Permissions.SYSTEMADMINISTRATION)
                            },
                            {
                                name: 'PAGE.MASTERDATA.PSA.TXT',
                                route: '/masterdata/#/PSA',
                                permission: this.permissions.includes(Permissions.SYSTEMADMINISTRATION)
                            },
                            {
                                name: 'PAGE.MASTERDATA.DWSM.TXT',
                                route: '/masterdata/#dwsm',
                                permission:
                                    this.permissions.includes(Permissions.SYSTEMADMINISTRATION) &&
                                    this.permissions.includes(Permissions.RECALCULATE_RISK_INDICES)
                            },
                            {
                                name: 'PAGE.MEASURECATALOG.APPLICATION.MEASURECATALOG.LBL',
                                route: '/masterdata/#measureCatalog',
                                permission: this.permissions.includes(Permissions.SYSTEMADMINISTRATION)
                            }
                        ]
                    },
                    {
                        name: 'PAGE.NAV.APPLICATION.TXT',
                        permission: this.permissions.includes(Permissions.SYSTEMADMINISTRATION),
                        items: [
                            {
                                name: 'PAGE.TOTALANALYSIS.APPLICATION.TOTALANALYSIS.LBL',
                                route: '/appadmin/#/config/totalAnalysis',
                                permission: true
                            },
                            {
                                name: 'ENUM.SEARCH_RESULT_COLUMN.MM01',
                                route: '/appadmin/#/config/criterion1',
                                permission: true
                            },
                            {
                                name: 'ENUM.SEARCH_RESULT_COLUMN.MM02',
                                route: '/appadmin/#/config/criterion2',
                                permission: true
                            },
                            {
                                name: 'ENUM.SEARCH_RESULT_COLUMN.MM03',
                                route: '/appadmin/#/config/criterion3',
                                permission: true
                            },
                            {
                                name: 'ENUM.SEARCH_RESULT_COLUMN.MM04',
                                route: '/appadmin/#/config/criterion4',
                                permission: true
                            },
                            {
                                name: 'ENUM.SEARCH_RESULT_COLUMN.MM05',
                                route: '/appadmin/#/config/criterion5',
                                permission: true
                            },
                            {
                                name: 'ENUM.SEARCH_RESULT_COLUMN.MM06',
                                route: '/appadmin/#/config/criterion6',
                                permission: true
                            },
                            {
                                name: 'ENUM.SEARCH_RESULT_COLUMN.MM07',
                                route: '/appadmin/#/config/criterion7',
                                permission: true
                            },
                            {
                                name: 'ENUM.SEARCH_RESULT_COLUMN.MM08',
                                route: '/appadmin/#/config/criterion8',
                                permission: true
                            },
                            {
                                name: 'ENUM.SEARCH_RESULT_COLUMN.MM09',
                                route: '/appadmin/#/config/criterion9',
                                permission: true
                            },
                            {
                                name: 'ENUM.SEARCH_RESULT_COLUMN.MM10',
                                route: '/appadmin/#/config/criterion10',
                                permission: true
                            },
                            {
                                name: 'ENUM.SEARCH_RESULT_COLUMN.MM11',
                                route: '/appadmin/#/config/criterion11',
                                permission: true
                            },
                            {
                                name: 'ENUM.SEARCH_RESULT_COLUMN.MM12',
                                route: '/appadmin/#/config/criterion12',
                                permission: true
                            },
                            {
                                name: 'ENUM.SEARCH_RESULT_COLUMN.MM13',
                                route: '/appadmin/#/config/criterion13',
                                permission: true
                            },
                            {
                                name: 'PAGE.ANALYSIS.PRINT_PARAMS.ERGOMAN.TXT',
                                route: '/appadmin/#/config/ergoman',
                                permission: true
                            },
                            {
                                name: 'PAGE.APPADMIN.ENTIRE.ANALYSIS.TXT',
                                route: '/appadmin/#/config/entireAnalysis',
                                permission: true
                            }
                        ]
                    },
                    {
                        name: 'PAGE.NAV.SYSTEM.TXT',
                        permission: this.permissions.includes(Permissions.SYSTEMADMINISTRATION),
                        items: [
                            {
                                name: 'PAGE.SYSADMIN.TEXTVALUE.TXT',
                                route: '/sysadmin/#/key',
                                permission: true
                            },
                            {
                                name: 'PAGE.UADMIN.EXPIRATION.NOTIFICATION.LBL',
                                route: '/sysadmin/#/accessExpirationNotification',
                                permission: true
                            },
                            {
                                name: 'PAGE.SYSADMIN.ANALYSIS_CALC_SETTINGS.LBL',
                                route: '/sysadmin/#/AnalysisCalcConfig',
                                permission: true
                            },
                            {
                                name: 'PAGE.SYSADMIN.ANALYSIS_FORMULA_CHECKER.LBL',
                                route: '/sysadmin/#/FormulaChecker',
                                permission: true
                            },
                            {
                                name: 'PAGE.SYSADMIN.OPS.TXT',
                                route: '/sysadmin/#/operations',
                                permission: this.permissions.includes(UserTypePermission.SUPER_USER)
                            }
                        ]
                    },
                    {
                        name: 'PAGE.TEMPLATE.TEMPLATES.LBL',
                        permission: this.permissions.includes(Permissions.MASTER_DATA_ADMINISTRATION),
                        items: [
                            {
                                name: 'PAGE.SYSADMIN.TEMPLATE.SIMPLE_SEARCH.TXT',
                                route: '/sysadmin/#/templates/simpleSearch',
                                permission: true
                            },
                            {
                                name: 'PAGE.SYSADMIN.TEMPLATE.CATALOG.TXT',
                                route: '/sysadmin/#/templates/catalog',
                                permission: true
                            }
                        ]
                    },
                    {
                        name: 'PAGE.NAV.HELP.TXT',
                        permission: this.permissions.includes(Permissions.SYSTEMADMINISTRATION),
                        items: [
                            {
                                name: 'PAGE.NAV.HELP.TXT',
                                route: '/helpadmin/#/help',
                                permission: this.permissions.includes(Permissions.SYSTEMADMINISTRATION)
                            },
                            {
                                name: 'PAGE.HELPADMIN.TOOLTIP.TXT',
                                route: '/helpadmin/#/tooltip',
                                permission: this.permissions.includes(Permissions.SYSTEMADMINISTRATION)
                            }
                        ]
                    }
                ]
            }
        ];
        this.emitValueMenuObj.emit(this.leftNavigation);
    }
}
